import { css, type Theme } from "@emotion/react";

import { dimensions } from "@styles";

export const emptyState = {
  base: (theme: Theme) => css`
    text-align: center;
    box-shadow: none;
    width: 100%;
    background-color: ${theme.surface.level1};
  `,
  borderless: css`
    border: 1px solid transparent;
  `,
};

export const emptyStateContent = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const icon = css`
  margin-bottom: 1rem;
`;

export const text = css`
  max-width: 43.75rem;
`;

export const title = css`
  margin-bottom: 0.25rem;
`;

export const action = css`
  @media only screen and (max-width: ${dimensions.phoneLargeMax}) {
    width: 100%;
  }
`;
